export const MODAL_TARGET = 'isOpen';
